export function isTokenValid(token) {
  if (!token || typeof token !== "string") return false;
  const parts = token.split(".");
  if (parts.length !== 3) return false;
  try {
    const payload = JSON.parse(atob(parts[1]));
    if (!payload?.exp) return false;
    return payload.exp * 1000 > Date.now() + 5000;
  } catch {
    return false;
  }
}

export function isAdminPath(pathname) {
  return typeof pathname === "string" && pathname.startsWith("/admin");
}

export function clearAdminSession() {
  localStorage.removeItem("admin_token");
  localStorage.removeItem("admin_role");
}

export function getAdminToken() {
  const token = localStorage.getItem("admin_token");
  return isTokenValid(token) ? token : null;
}
